import * as React from 'react';
import { ViewerContext } from 'context/ViewerContext';

const useViewer = () => {
  const viewer = React.useContext(ViewerContext);
  return viewer;
};

export default useViewer;
